import script from "./NotFoundReservaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundReservaForm.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundReservaForm.vue?vue&type=style&index=0&id=31177c74&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31177c74"]])

export default __exports__